import type { LandingHeroRotatorPair } from '@/interfaces/LandingHeroRotatorPair';

const normalizeLandingHeroRotatorTerms = (terms: readonly string[]): string[] => terms.map((term) => term.trim()).filter(Boolean);

export const getLandingHeroRotatorPairs = (rawSubjects: readonly string[], rawAudiences: readonly string[]): LandingHeroRotatorPair[] => {
    const subjects = normalizeLandingHeroRotatorTerms(rawSubjects);
    const audiences = normalizeLandingHeroRotatorTerms(rawAudiences);
    const subjectCount = subjects.length;
    const audienceCount = audiences.length;
    const pairCount = subjectCount * audienceCount;

    if (pairCount === 0) {
        return [];
    }

    return Array.from({ length: pairCount }, (_, index) => {
        const subjectIndex = index % subjectCount;
        const audienceGroupIndex = Math.floor(index / subjectCount);
        const audienceIndex = subjectCount === audienceCount ? (subjectIndex + audienceGroupIndex) % audienceCount : audienceGroupIndex;
        const subject = subjects[subjectIndex];
        const audience = audiences[audienceIndex];

        return {
            audience,
            key: `${index}:${subject}:${audience}`,
            subject,
        };
    });
};
